module.exports = __webpack_public_path__ + "static/media/Lugnet-VC-logo.c5273c50.webp";